export const extractInitials = (nombre: string) => {
    const parts = nombre.trim().split(' ');
    if (parts.length === 0) return '?';
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export const getBadgeFontSize = (initials: string) => {
    if (initials.length <= 2) return '14px';
    if (initials.length === 3) return '12px';
    return '10px';
}

export const getBadgeRadius = (initials: string) => {
    if (initials.length <= 2) return 12;
    if (initials.length === 3) return 13;
    return 14;
}

export const buildGeriatricoMarkerIcon = (opts: { initials: string; active: boolean }) => {
    const { initials, active } = opts;
    const color = active ? '#4f46e5' : '#6b7280';
    const fontSize = getBadgeFontSize(initials);
    const r = getBadgeRadius(initials);

    const svg = `
        <svg width="48" height="48" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
            <defs>
                <filter id="shadow" x="-20%" y="-20%" width="140%" height="140%">
                    <feDropShadow dx="0" dy="2" stdDeviation="3" flood-opacity="0.25"/>
                </filter>
            </defs>

            <path
                d="M24 46s-16-15-16-26C8 11.2 15.2 4 24 4s16 7.2 16 16c0 11-16 26-16 26z"
                fill="${color}"
                filter="url(#shadow)"
            />

            <circle cx="24" cy="18" r="${r}" fill="white" />
            <circle cx="24" cy="18" r="${r}" fill="none" stroke="rgba(0,0,0,0.06)" />

            <text
                x="24"
                y="22"
                text-anchor="middle"
                font-size="${fontSize}"
                font-weight="800"
                fill="${color}"
                font-family="Inter, system-ui, -apple-system, Arial, sans-serif"
                letter-spacing="${initials.length === 4 ? '-0.5' : '0'}"
            >${initials}</text>
        </svg>
    `;

    return {
        url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
        scaledSize: new window.google.maps.Size(48, 48),
        anchor: new window.google.maps.Point(24, 46),
    };
}
